
import gif from './media/gif';

// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
export default {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" ' + 'src="' + gif + '">';

    return element.querySelector('img');
  }
};
//# sourceMappingURL=focus-img-usemap-tabindex.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ally.js/esm/supports/focus-img-usemap-tabindex.js
// module id = 184
// module chunks = 0 1